export const locationType = {
  REQUEST_LOCATION: "REQUEST_LOCATION",
  GET_ALL_LOCATION: "GET_ALL_LOCATION",
};
